import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSpeed = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.8321 9.55463C17.1384 9.0951 17.0142 8.47423 16.5547 8.16788C16.0952 7.86153 15.4743 7.98572 15.168 8.44525L15.0119 8.67931C14.0996 8.24381 13.0783 8 12 8C8.13401 8 5 11.134 5 15C5 15.3385 5.02411 15.672 5.07084 15.9987C5.14904 16.5455 5.65564 16.9253 6.20236 16.8471C6.74908 16.7689 7.12889 16.2623 7.05069 15.7155C7.01733 15.4824 7 15.2435 7 15C7 12.2386 9.23858 10 12 10C12.6673 10 13.3041 10.1307 13.8862 10.368L11.168 14.4454C10.8616 14.9049 10.9858 15.5258 11.4453 15.8321C11.9049 16.1385 12.5257 16.0143 12.8321 15.5548L15.5495 11.4785C16.4461 12.3822 17 13.6264 17 15C17 15.2435 16.9827 15.4824 16.9493 15.7155C16.8711 16.2623 17.2509 16.7689 17.7976 16.8471C18.3444 16.9253 18.851 16.5455 18.9292 15.9987C18.9759 15.672 19 15.3385 19 15C19 12.9309 18.1023 11.0715 16.6751 9.79002L16.8321 9.55463Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgSpeed);
export { ForwardRef as ReactComponent };
